import { render, staticRenderFns } from "./ConflictPrompt.vue?vue&type=template&id=6a2cd274&scoped=true"
import script from "./ConflictPrompt.vue?vue&type=script&lang=js"
export * from "./ConflictPrompt.vue?vue&type=script&lang=js"
import style0 from "./ConflictPrompt.vue?vue&type=style&index=0&id=6a2cd274&prod&scoped=true&lang=css"
import style1 from "./ConflictPrompt.vue?vue&type=style&index=1&id=6a2cd274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2cd274",
  null
  
)

export default component.exports